import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Contact from "../containers/Contact"

type ContactPageProps = {}

const ContactPage: React.FunctionComponent<ContactPageProps> = props => {
  return (
    <Layout>
      <SEO
        title="Contact Me"
        description="I answer quickly"
        image="https://www.freeiconspng.com/uploads/blue-phone-icon--premier-rides-13.jpg"
      />

      <Contact />
    </Layout>
  )
}

export default ContactPage
